import { useMemo } from 'react';
import featureFlagService from '../service/FeatureFlagService';
/**
 * Hook to check if a single feature flag is enabled
 * @param flag The feature flag to check
 * @returns boolean indicating if the feature is enabled
 */
export function useFeatureFlag(flag) {
    return useMemo(() => featureFlagService.isEnabled(flag), [flag]);
}
/**
 * Hook to get list of enabled product keys
 * @returns Array of product keys that are enabled by feature flags
 */
export function useEnabledProducts() {
    return useMemo(() => featureFlagService.getEnabledProducts(), []);
}
